import React, { useEffect, useState, createContext, useContext } from 'react';
interface LanguageContextType {
  isArabic: boolean;
  toggleLanguage: () => void;
}
const LanguageContext = createContext<LanguageContextType>({
  isArabic: false,
  toggleLanguage: () => {}
});
export const useLanguage = () => useContext(LanguageContext);
export const LanguageProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isArabic, setIsArabic] = useState(false);
  useEffect(() => {
    // Check for saved language preference
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage === 'ar') {
      setIsArabic(true);
      document.documentElement.dir = 'rtl';
    } else {
      setIsArabic(false);
      document.documentElement.dir = 'ltr';
    }
  }, []);
  const toggleLanguage = () => {
    setIsArabic(prev => {
      const newValue = !prev;
      localStorage.setItem('language', newValue ? 'ar' : 'en');
      if (newValue) {
        document.documentElement.dir = 'rtl';
      } else {
        document.documentElement.dir = 'ltr';
      }
      return newValue;
    });
  };
  return <LanguageContext.Provider value={{
    isArabic,
    toggleLanguage
  }} data-id="element-1728">
      {children}
    </LanguageContext.Provider>;
};